
(function ($) {




	function sidebarNavigationTouch() {
		const $nav = $(".sidebar__nav");
		let startX = 0;
		let startY = 0;
		let isDragging = false;
		let currentTranslateX = 0;
		let verticalScroll = false;

		function closeNav() {
			currentTranslateX = 0;
			isDragging = false;
			$(".navigation__hamburger-icon").removeClass("navigation__hamburger-icon--opened");
			$(".navigation__hamburger").removeClass("navigation__hamburger--opened");
			$('html').removeClass('overflow_hidden');
			$("[data-modal-id='nav']").removeClass('opened')
			$('body').removeClass('has-modal')
			// $nav.css('transform', `translate(calc(100% + 20px), 0)`);
			$nav.css('transform', '');
		}

		$nav.on('touchstart', function (e) {
			startX = e.touches[0].clientX;
			startY = e.touches[0].clientY;
			// console.log(e.target);
			// if (e.target.hasClass('.sidebar__nav')) {
				isDragging = true;
			// }
		});

		$('.nav_m__header').on('touchstart', function(event) {
			event.stopPropagation();
			isDragging = false;
		});
		$nav.on('touchmove', function (e) {
			if (!isDragging) return;
			let touchX = e.touches[0].clientX;
			let touchY = e.touches[0].clientY;
			let distance = touchX - startX;
			let distanceY = touchY - startY;
			if (Math.abs(distanceY) >= 5 && Math.abs(distance) <= 5){ //Make sure that slider won't close if scrolling only vertically
				verticalScroll = true;
			}
			$nav.css('transition', 'none');
			if (!verticalScroll){
				if (distance > 0) { //Scroll down
					$nav.css('transform', `translateX(${distance}px)`);
					currentTranslateX = distance;
				} else {
					currentTranslateX = 0;
				}
			}
		});

		$nav.on('touchend', function (e) {
			if (!isDragging) return;

			$nav.css('transition', '');
			let touchX = e.changedTouches[0].clientX;
			let touchY = e.changedTouches[0].clientY;
			let distance = touchX - startX;
			let distanceY = touchY - startY;
			// Thresholds
			let distanceThreshold = 100;
			if (Math.abs(distanceY) >= 5 && Math.abs(distance) <= 5){ //Make sure that slider won't close if scrolling only vertically
				verticalScroll = true;
			}
			if (!verticalScroll){
				if (distance > distanceThreshold) { //Scroll down
					closeNav();
					setTimeout(function () {
						$nav.css('transform', '');
					}, 200);
				} else {
					$nav.css('transform', 'translateX(0)');
				}
			}
			verticalScroll = false;
		});

	}


	function sidebarTouch() {
		$(".sidebar:not(.sidebar__nav)").each(function () {
			const $sidebar = $(this);
			const $sidebarContent = $(this).find('.sidebar-content');
			const $content = $(this).find('.sidebar__content');
			let startY = 0;
			let startTime = 0;
			let currentTranslateY = 0;
			let isDragging = false;
			let draggingContent = false;

			function closeModal() {
				$('body').removeClass('has-modal');
				$sidebar.removeClass('opened fullscreen').css('transform', '');
				currentTranslateY = 0;
				isDragging = false;
			}

			const contentHeight = () => {
				let $name;
				if($(window).height() * 0.5 + 150 - $sidebarContent.outerHeight() > 0) {
					$name = 'small';
				} else if($(window).height() - $sidebarContent.outerHeight() >= 200) {
					$name = 'medium';
				} else {
					$name = 'big';
					$sidebarContent.addClass('fullscreen');
				}
				return $name
			};

			$sidebar.addClass('sidebar-'+contentHeight());

			$sidebarContent.on('touchstart', function (e) {
				startY = e.touches[0].clientY;
				startTime = new Date().getTime();
				isDragging = true;
			});

			//Check if dragging inner content
			$sidebarContent.find('.sidebar__content').on('touchstart', function () {
				if ($content.scrollTop() !== 0) {
					draggingContent = true;
				}
			});
			$sidebarContent.find('.sidebar__content').on('touchend', function () {
				setTimeout(function(){
					draggingContent = false;
				}, 1);
			});

			$sidebarContent.on('touchmove', function (e) {
				if (!isDragging) return;
				if (draggingContent) return;
				if ($(this).closest('.sidebar').hasClass('sidebar__search')) return;

				let touchY = e.touches[0].clientY;
				let distance = touchY - startY;
				$sidebarContent.css('transition', 'none');

				switch (contentHeight()){
					case 'small':
						if (distance > 0) { //Scroll down
							$sidebarContent.css('transform', `translateY(${distance}px)`);
							currentTranslateY = distance;
							// } else if (distance > -30) {
							// 	$sidebarContent.css('transform', `translateY(${distance}px)`);
							// 	currentTranslateY = distance;
						} else {
							currentTranslateY = 0;
						}
						break;
					default:
						if (distance > 0) { //Scroll down
							$sidebarContent.css('transform', `translateY(${distance}px)`);
							currentTranslateY = distance;

						} else {
							if (!$sidebarContent.hasClass('fullscreen')) {
								$sidebarContent.css('transform', `translateY(${distance}px)`);
								currentTranslateY = distance;
							}
						}
						break;
				}

			});

			$sidebarContent.on('touchend', function (e) {
				if (!isDragging) return;
				if (draggingContent) return;
				if ($(this).closest('.sidebar').hasClass('sidebar__search')) return;

				$sidebarContent.css('transition', '');
				let touchY = e.changedTouches[0].clientY;
				let endTime = new Date().getTime();
				let distance = touchY - startY + 150;
				let timeTaken = endTime - startTime;
				let velocity = Math.abs(distance) / timeTaken;

				// Thresholds
				let distanceThreshold = 250; // 300px threshold
				let velocityThreshold = 0.5; // velocity threshold

				if (distance > distanceThreshold) { //Scroll down
					closeModal();
					setTimeout(function(){
						$sidebarContent.css('transform', '');
						$sidebarContent.removeClass('fullscreen');
					}, 200);

				} else {
					$sidebarContent.css('transform', 'translateY(0)');
					if (!$sidebarContent.hasClass('fullscreen')){
						$sidebarContent.css('transform', 'translateY(0)');
						if (contentHeight() !== 'small') {
							$sidebarContent.addClass('fullscreen');
						}
					}
				}



				if (distance > distanceThreshold || velocity > velocityThreshold) {
					// closeModal();
					if (distance > 0) { //Scroll down
					} else { //Scroll up
						// $sidebarContent.css('transform', `translateY(0)`);
						// $sidebarContent.css('top', `0`);
					}
				} else {
					// $sidebarContent.css('transform', `translateY(${currentTranslateY}px)`);
					// $sidebarContent.css('top', `${currentTranslateY}px`);
				}

				isDragging = false;

			});

		});
	}

	$(document).gp_ready(function (){
		sidebarTouch();
		sidebarNavigationTouch();
	})


})(jQuery);


